(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root['openrndr-js'] = factory(typeof this['openrndr-js'] === 'undefined' ? {} : this['openrndr-js']);
}(this, function (_) {
  'use strict';
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$break: while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this_.iterator_14();
    $l$break: while (tmp0_iterator.hasNext_1()) {
      var element = tmp0_iterator.next_1();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString(it);
  };
  _no_name_provided_.prototype.invoke_52 = function (p1) {
    return this.invoke((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      return i.invoke(p1);
    };
  }
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size) {
    if (index < 0 ? true : index >= size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype.iterator_14 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_1 = function () {
    return false;
  };
  EmptyIterator.prototype.next_1 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function Annotation() {
  }
  Annotation.$metadata$ = {
    simpleName: 'Annotation',
    kind: 'interface',
    interfaces: []
  };
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function DoubleCompanionObject_0() {
    DoubleCompanionObject_instance = this;
    this._MIN_VALUE = 4.9E-324;
    this._MAX_VALUE = 1.7976931348623157E308;
    this._POSITIVE_INFINITY = Infinity;
    this._NEGATIVE_INFINITY = -Infinity;
    this._NaN = NaN;
    this._SIZE_BYTES = 8;
    this._SIZE_BITS = 64;
  }
  DoubleCompanionObject_0.prototype._get_MIN_VALUE_ = function () {
    return this._MIN_VALUE;
  };
  DoubleCompanionObject_0.prototype._get_MAX_VALUE_ = function () {
    return this._MAX_VALUE;
  };
  DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY_ = function () {
    return this._POSITIVE_INFINITY;
  };
  DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY_ = function () {
    return this._NEGATIVE_INFINITY;
  };
  DoubleCompanionObject_0.prototype._get_NaN_ = function () {
    return this._NaN;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BYTES_ = function () {
    return this._SIZE_BYTES;
  };
  DoubleCompanionObject_0.prototype._get_SIZE_BITS_ = function () {
    return this._SIZE_BITS;
  };
  DoubleCompanionObject_0.$metadata$ = {
    simpleName: 'DoubleCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MIN_VALUE_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_MAX_VALUE_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'POSITIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_POSITIVE_INFINITY_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NEGATIVE_INFINITY', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NEGATIVE_INFINITY_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'NaN', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_NaN_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BYTES_
  });
  Object.defineProperty(DoubleCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: DoubleCompanionObject_0.prototype._get_SIZE_BITS_
  });
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    if (DoubleCompanionObject_instance == null)
      new DoubleCompanionObject_0();
    return DoubleCompanionObject_instance;
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator = collection.iterator_14();
    while (iterator.hasNext_1()) {
      array.push(iterator.next_1());
    }
    return array;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index = 0;
    this._last = -1;
  }
  IteratorImpl.prototype.hasNext_1 = function () {
    return this._index < this._$this._get_size__0();
  };
  IteratorImpl.prototype.next_1 = function () {
    if (!this.hasNext_1())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index;
    tmp0_this._index = tmp1 + 1 | 0;
    tmp._last = tmp1;
    return this._$this.get_11(this._last);
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype.iterator_14 = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__0());
    return index;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__0 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_11 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_0 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_0();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function _get_ulp_(_this_) {
    return _this_ < 0.0 ? _get_ulp_(-_this_) : (isNaN_0(_this_) ? true : _this_ === Infinity) ? _this_ : _this_ === 1.7976931348623157E308 ? _this_ - nextDown(_this_) : nextUp(_this_) - _this_;
  }
  function nextDown(_this_) {
    var tmp;
    if (isNaN_0(_this_) ? true : _this_ === -Infinity) {
      tmp = _this_;
    } else if (_this_ === 0.0) {
      tmp = -4.9E-324;
    } else {
      var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
      var tmp0_plus_0 = toRawBits(_this_);
      var tmp1_plus_0 = _this_ > 0.0 ? -1 : 1;
      var tmp3_fromBits_0 = tmp0_plus_0.plus_28(toLong(tmp1_plus_0));
      tmp = doubleFromBits(tmp3_fromBits_0);
    }
    return tmp;
  }
  function nextUp(_this_) {
    var tmp;
    if (isNaN_0(_this_) ? true : _this_ === Infinity) {
      tmp = _this_;
    } else if (_this_ === 0.0) {
      tmp = 4.9E-324;
    } else {
      var tmp2_fromBits_0 = DoubleCompanionObject_getInstance();
      var tmp0_plus_0 = toRawBits(_this_);
      var tmp1_plus_0 = _this_ > 0.0 ? 1 : -1;
      var tmp3_fromBits_0 = tmp0_plus_0.plus_28(toLong(tmp1_plus_0));
      tmp = doubleFromBits(tmp3_fromBits_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__2();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype._get_simpleName__2 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  var functionClasses;
  function _no_name_provided__0() {
  }
  _no_name_provided__0.prototype.invoke_41 = function (it) {
    return isObject(it);
  };
  _no_name_provided__0.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__1() {
  }
  _no_name_provided__1.prototype.invoke_41 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__1.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__1.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__2() {
  }
  _no_name_provided__2.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__2.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__3() {
  }
  _no_name_provided__3.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__3.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__4() {
  }
  _no_name_provided__4.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__4.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__5() {
  }
  _no_name_provided__5.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__5.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__6() {
  }
  _no_name_provided__6.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__6.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__7() {
  }
  _no_name_provided__7.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__7.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__8() {
  }
  _no_name_provided__8.prototype.invoke_41 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__8.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__9() {
  }
  _no_name_provided__9.prototype.invoke_41 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__9.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__10() {
  }
  _no_name_provided__10.prototype.invoke_41 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__10.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__11() {
  }
  _no_name_provided__11.prototype.invoke_41 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__11.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__12() {
  }
  _no_name_provided__12.prototype.invoke_41 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__12.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__13() {
  }
  _no_name_provided__13.prototype.invoke_41 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__13.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14() {
  }
  _no_name_provided__14.prototype.invoke_41 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__14.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__15() {
  }
  _no_name_provided__15.prototype.invoke_41 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__15.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_41 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__16.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17() {
  }
  _no_name_provided__17.prototype.invoke_41 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__17.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_41 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__18.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__19.prototype.invoke_41 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__19.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_0());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_1());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_2());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_3());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_4());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_5());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_6());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_7());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_8());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_9());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_10());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_11());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_12());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_13());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_14());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_15());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_16());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_17());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_18());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_19(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_0() {
    var i = new _no_name_provided__0();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_1() {
    var i = new _no_name_provided__1();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_2() {
    var i = new _no_name_provided__2();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_3() {
    var i = new _no_name_provided__3();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_4() {
    var i = new _no_name_provided__4();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__5();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_6() {
    var i = new _no_name_provided__6();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__7();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_8() {
    var i = new _no_name_provided__8();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__9();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__10();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__11();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__12();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__13();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__14();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__15();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__16();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__17();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__18();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function _no_name_provided_$factory_19($arity) {
    var i = new _no_name_provided__19($arity);
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$() {
    return StringBuilder_init_$Init$(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype.append_2 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString(value);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function Char() {
  }
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function toString(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_0(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last = array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last));
    return array;
  }
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function doubleFromBits(value) {
    bufInt32[lowIndex] = value._low;
    bufInt32[highIndex] = value._high;
    return bufFloat64[0];
  }
  function doubleToRawBits(value) {
    bufFloat64[0] = value;
    return new Long(bufInt32[lowIndex], bufInt32[highIndex]);
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_20(), 24, null);
  }
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_41 = function (it) {
    return toString_0(it);
  };
  _no_name_provided__20.prototype.invoke_52 = function (p1) {
    return this.invoke_41((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__20();
    return function (p1) {
      return i.invoke_41(p1);
    };
  }
  function toString_0(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function Companion_1() {
    Companion_instance_0 = this;
    this._MIN_VALUE_0 = new Long(0, -2147483648);
    this._MAX_VALUE_0 = new Long(-1, 2147483647);
    this._SIZE_BYTES_0 = 8;
    this._SIZE_BITS_0 = 64;
  }
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function Long(low, high) {
    Companion_getInstance_0();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.plus_28 = function (other) {
    return add(this, other);
  };
  Long.prototype.div_27 = function (other) {
    return divide(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_28(new Long(1, 0));
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_4 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_27(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_27(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_27(negate(other));
      } else {
        tmp = negate(negate(_this_).div_27(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_27(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_27(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_4();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_27(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_4();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_4();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function toLong(a) {
    return fromInt(a);
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$(message) {
    var tmp = UnsupportedOperationException_init_$Init$(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function toRawBits(_this_) {
    return doubleToRawBits(_this_);
  }
  function SerializableWith() {
  }
  SerializableWith.$metadata$ = {
    simpleName: 'SerializableWith',
    kind: 'class',
    interfaces: [Annotation],
    associatedObjectKey: 0
  };
  var MACHINE_EPSILON;
  function mod(a, b) {
    return (a % b + b) % b;
  }
  function LinearType() {
  }
  LinearType.$metadata$ = {
    simpleName: 'LinearType',
    kind: 'interface',
    interfaces: []
  };
  function Companion_2() {
    Companion_instance_1 = this;
    this._ZERO = new Vector2(0.0, 0.0);
    this._ONE = new Vector2(1.0, 1.0);
    this._UNIT_X = new Vector2(1.0, 0.0);
    this._UNIT_Y = new Vector2(0.0, 1.0);
    this._INFINITY = new Vector2(Infinity, Infinity);
  }
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function Vector2(x, y) {
    Companion_getInstance_1();
    this._x = x;
    this._y = y;
  }
  Vector2.prototype.toString = function () {
    return '' + 'Vector2(x=' + this._x + ', y=' + this._y + ')';
  };
  Vector2.$metadata$ = {
    simpleName: 'Vector2',
    kind: 'class',
    interfaces: [LinearType]
  };
  function Vector3_init_$Init$(x, $this) {
    Vector3.call($this, x, x, x);
    return $this;
  }
  function Vector3_init_$Create$(x) {
    return Vector3_init_$Init$(x, Object.create(Vector3.prototype));
  }
  function Companion_3() {
    Companion_instance_2 = this;
    this._ZERO_0 = new Vector3(0.0, 0.0, 0.0);
    this._ONE_0 = new Vector3(1.0, 1.0, 1.0);
    this._UNIT_X_0 = new Vector3(1.0, 0.0, 0.0);
    this._UNIT_Y_0 = new Vector3(0.0, 1.0, 0.0);
    this._UNIT_Z = new Vector3(0.0, 0.0, 1.0);
    this._INFINITY_0 = new Vector3(Infinity, Infinity, Infinity);
  }
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function Vector3(x, y, z) {
    Companion_getInstance_2();
    this._x_0 = x;
    this._y_0 = y;
    this._z = z;
  }
  Vector3.prototype.plus_0 = function (v) {
    return new Vector3(this._x_0 + v._x_0, this._y_0 + v._y_0, this._z + v._z);
  };
  Vector3.prototype.minus = function (v) {
    return new Vector3(this._x_0 - v._x_0, this._y_0 - v._y_0, this._z - v._z);
  };
  Vector3.prototype.times = function (v) {
    return new Vector3(this._x_0 * v._x_0, this._y_0 * v._y_0, this._z * v._z);
  };
  Vector3.prototype.toString = function () {
    return '' + 'Vector3(x=' + this._x_0 + ', y=' + this._y_0 + ', z=' + this._z + ')';
  };
  Vector3.$metadata$ = {
    simpleName: 'Vector3',
    kind: 'class',
    interfaces: [LinearType]
  };
  function min(a, b) {
    var tmp0_min_0 = a._x_0;
    var tmp1_min_0 = b._x_0;
    var tmp = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_min_0, tmp1_min_0]))));
    }.call(this);
    var tmp2_min_0 = a._y_0;
    var tmp3_min_0 = b._y_0;
    var tmp_0 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp2_min_0, tmp3_min_0]))));
    }.call(this);
    var tmp4_min_0 = a._z;
    var tmp5_min_0 = b._z;
    return new Vector3(tmp, tmp_0, function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.min.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp4_min_0, tmp5_min_0]))));
    }.call(this));
  }
  function max(a, b) {
    var tmp0_max_0 = a._x_0;
    var tmp1_max_0 = b._x_0;
    var tmp = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp0_max_0, tmp1_max_0]))));
    }.call(this);
    var tmp2_max_0 = a._y_0;
    var tmp3_max_0 = b._y_0;
    var tmp_0 = function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp2_max_0, tmp3_max_0]))));
    }.call(this);
    var tmp4_max_0 = a._z;
    var tmp5_max_0 = b._z;
    return new Vector3(tmp, tmp_0, function () {
      var $externalVarargReceiverTmp = Math;
      return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([tmp4_max_0, tmp5_max_0]))));
    }.call(this));
  }
  var hues;
  function Hue(name, lambda, angle, xbl, ybl, zbl, xl, yl, sl) {
    this._name = name;
    this._lambda = lambda;
    this._angle = angle;
    this._xbl = xbl;
    this._ybl = ybl;
    this._zbl = zbl;
    this._xl = xl;
    this._yl = yl;
    this._sl = sl;
  }
  Hue.prototype.toString = function () {
    return '' + 'Hue(name=' + this._name + ', lambda=' + this._lambda + ', angle=' + this._angle + ', xbl=' + this._xbl + ', ybl=' + this._ybl + ', zbl=' + this._zbl + ', xl=' + this._xl + ', yl=' + this._yl + ', sl=' + this._sl + ')';
  };
  Hue.$metadata$ = {
    simpleName: 'Hue',
    kind: 'class',
    interfaces: []
  };
  var c1;
  var x1;
  var y1;
  var c2;
  var x2;
  var y2;
  function toRgbInt(component) {
    return numberToInt(component * 255.0);
  }
  function toRgbaColor(_this_, alpha) {
    return '' + 'rgba(' + toRgbInt(_this_._x_0) + ',' + toRgbInt(_this_._y_0) + ',' + toRgbInt(_this_._z) + ',' + alpha + ')';
  }
  function spectralZucconi6(x) {
    return bump3y(c1.times(Vector3_init_$Create$(x).minus(x1)), y1).plus_0(bump3y(c2.times(Vector3_init_$Create$(x).minus(x2)), y2));
  }
  function saturate(x) {
    return min(Companion_getInstance_2()._ONE_0, max(Companion_getInstance_2()._ZERO_0, x));
  }
  function bump3y(x, yoffset) {
    var tmp0_let_0 = Companion_getInstance_2()._ONE_0.minus(x.times(x));
    return saturate(tmp0_let_0.minus(yoffset));
  }
  var FLIP_Y;
  function main() {
    var tmp = window;
    tmp.onload = _no_name_provided_$factory_21();
  }
  function _get_painter_() {
    var tmp = painter;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('painter');
    }
  }
  var painter;
  function _get_canvas_() {
    return _get_painter_()._canvas2d;
  }
  function _get_time_() {
    return _get_painter_()._time;
  }
  function _get_width_() {
    return _get_painter_()._width;
  }
  function _get_height_() {
    return _get_painter_()._height;
  }
  function Painter_init_$Init$(backgroundFillStyle, drawFunction, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      backgroundFillStyle = 'black';
    Painter.call($this, backgroundFillStyle, drawFunction);
    return $this;
  }
  function Painter_init_$Create$(backgroundFillStyle, drawFunction, $mask0, $marker) {
    return Painter_init_$Init$(backgroundFillStyle, drawFunction, $mask0, $marker, Object.create(Painter.prototype));
  }
  function render($this) {
    var tmp = window;
    tmp.requestAnimationFrame(_no_name_provided_$factory_23($this));
    Unit_getInstance();
    if (maybeResize($this)) {
      resize($this);
    }$this._time = window.performance.now() / 1000;
    $this._drawFunction();
  }
  function maybeResize($this) {
    return !($this._cssWidth === $this._canvas.clientWidth) ? true : !($this._cssHeight === $this._canvas.clientHeight);
  }
  function resize($this) {
    var pixelRatio = window.devicePixelRatio;
    $this._cssWidth = $this._canvas.clientWidth;
    $this._cssHeight = $this._canvas.clientHeight;
    var tmp = $this;
    var tmp0_floor_0 = $this._cssWidth * pixelRatio;
    var tmp0_unsafeCast_0_1 = Math.floor(tmp0_floor_0);
    tmp._width = numberToInt(tmp0_unsafeCast_0_1);
    var tmp_0 = $this;
    var tmp1_floor_0 = $this._cssHeight * pixelRatio;
    var tmp0_unsafeCast_0_1_0 = Math.floor(tmp1_floor_0);
    tmp_0._height = numberToInt(tmp0_unsafeCast_0_1_0);
    $this._canvas.width = $this._width;
    $this._canvas.height = $this._height;
    $this._canvas2d.fillStyle = $this._backgroundFillStyle;
    $this._canvas2d.fillRect(0.0, 0.0, $this._width, $this._height);
  }
  function _no_name_provided__21(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__21.prototype.invoke_45 = function (it) {
    render(this._this$0_0);
  };
  _no_name_provided__21.prototype.invoke_52 = function (p1) {
    this.invoke_45((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22(this$0) {
    this._this$0_1 = this$0;
  }
  _no_name_provided__22.prototype.invoke_45 = function (it) {
    render(this._this$0_1);
  };
  _no_name_provided__22.prototype.invoke_52 = function (p1) {
    this.invoke_45((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Painter(backgroundFillStyle, drawFunction) {
    this._backgroundFillStyle = backgroundFillStyle;
    this._drawFunction = drawFunction;
    var tmp = this;
    var tmp0_safe_receiver = document.body;
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.appendChild(document.createElement('canvas'));
    tmp._canvas = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = function () {
      var $externalVarargReceiverTmp = this._canvas;
      return $externalVarargReceiverTmp.getContext.apply($externalVarargReceiverTmp, ['2d']);
    }.call(this);
    tmp_1._canvas2d = tmp_2 instanceof CanvasRenderingContext2D ? tmp_2 : THROW_CCE();
    var tmp0_with_0 = this._canvas.style;
    tmp0_with_0.position = 'fixed';
    tmp0_with_0.width = '100vw';
    tmp0_with_0.height = '100vh';
    tmp0_with_0.top = '0';
    tmp0_with_0.left = '0';
    tmp0_with_0.zIndex = '-10';
    var tmp_3 = window;
    tmp_3.requestAnimationFrame(_no_name_provided_$factory_22(this));
    Unit_getInstance();
    this._time = 0.0;
    this._width = 0;
    this._height = 0;
    this._cssWidth = 0;
    this._cssHeight = 0;
  }
  Painter.$metadata$ = {
    simpleName: 'Painter',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_47 = function () {
    draw();
  };
  _no_name_provided__23.prototype.invoke_48 = function () {
    this.invoke_47();
    return Unit_getInstance();
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_49 = function (it) {
    painter = Painter_init_$Create$(null, _no_name_provided_$factory_24(), 1, null);
    return true;
  };
  _no_name_provided__24.prototype.invoke_52 = function (p1) {
    return this.invoke_49(p1 instanceof Event ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_49(p1);
    };
  }
  function _no_name_provided_$factory_22(this$0) {
    var i = new _no_name_provided__21(this$0);
    return function (p1) {
      i.invoke_45(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_23(this$0) {
    var i = new _no_name_provided__22(this$0);
    return function (p1) {
      i.invoke_45(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_24() {
    var i = new _no_name_provided__23();
    return function () {
      i.invoke_47();
      return Unit_getInstance();
    };
  }
  var wave2;
  function wave(phase) {
    return (Math.sin(phase) + 1.0) / 2.0;
  }
  function oscillate(tempo, maxValue) {
    return wave(_get_time_() * tempo) * maxValue;
  }
  function oscillate_0(tempo, maxValue) {
    return oscillate(tempo, maxValue);
  }
  function draw() {
    var tmp0_with_0 = _get_canvas_();
    tmp0_with_0.beginPath();
    tmp0_with_0.moveTo(oscillate_0(1.0, _get_width_()), oscillate_0(1.1, _get_height_()));
    tmp0_with_0.lineWidth = 2.0;
    tmp0_with_0.strokeStyle = toRgbaColor(spectralZucconi6(mod(wave(_get_time_()), 1.0)), 0.2);
    tmp0_with_0.lineTo(oscillate_0(1.2, _get_width_()), oscillate_0(1.3, _get_height_()));
    tmp0_with_0.stroke();
    tmp0_with_0.closePath();
  }
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_51 = function (phase) {
    return (Math.sin(phase) + 1.0) / 2.0;
  };
  _no_name_provided__25.prototype.invoke_52 = function (p1) {
    return this.invoke_51((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_25() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_51(p1);
    };
  }
  function wave2$init$() {
    return _no_name_provided_$factory_25();
  }
  AbstractMutableList.prototype.get_11 = List.prototype.get_11;
  KClassImpl.prototype._get_simpleName__2 = KClass.prototype._get_simpleName__2;
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  MACHINE_EPSILON = _get_ulp_(1.0);
  hues = listOf([new Hue(10, 570.83, 59.0, 0.775745, 0.946572, 0.002032, 0.44987, 0.54895, 1.724349), new Hue(11, 572.64, 55.3, 0.80513, 0.933804, 0.00191, 0.46248, 0.53641, 1.740845), new Hue(12, 574.38, 51.7, 0.832782, 0.920395, 0.001808, 0.47451, 0.52444, 1.754986), new Hue(13, 576.06, 48.2, 0.858841, 0.906482, 0.001764, 0.48601, 0.51298, 1.767088), new Hue(14, 577.5, 44.8, 0.880488, 0.893741, 0.001724, 0.49578, 0.50325, 1.775953), new Hue(15, 579.31, 41.5, 0.906652, 0.876749, 0.001672, 0.5079, 0.49052, 1.785074), new Hue(16, 580.95, 38.2, 0.929124, 0.860368, 0.001612, 0.51874, 0.48035, 1.791104), new Hue(20, 582.65, 34.9, 0.950909, 0.842391, 0.001531, 0.5298, 0.46934, 1.794831), new Hue(21, 584.46, 31.5, 0.972454, 0.824779, 0.001431, 0.54137, 0.45783, 1.798665), new Hue(22, 586.43, 28.0, 0.993753, 0.799758, 0.001308, 0.55367, 0.44559, 1.794822), new Hue(23, 588.59, 24.4, 1.01435, 0.77409, 0.00117, 0.5668, 0.43253, 1.78961), new Hue(24, 591.06, 20.6, 1.034402, 0.774014, 0.001067, 0.58128, 0.41811, 1.779484), new Hue(25, 594.0, 16.6, 1.052466, 0.707496, 0.001021, 0.59766, 0.40176, 1.760984), new Hue(26, 597.74, 12.3, 1.062544, 0.660001, 8.98E-4, 0.61653, 0.383, 1.723444), new Hue(30, 602.72, 7.7, 1.056125, 0.59607, 6.96E-4, 0.63896, 0.36061, 1.652892), new Hue(31, 610.14, 2.8, 1.001027, 0.501245, 3.35E-4, 0.66619, 0.33358, 1.502608), new Hue(32, 625.0, -2.5, 0.7514, 0.321, 1.0E-4, 0.70061, 0.2993, 1.0725), new Hue(33, -492.79, -8.4, 0.726603, 0.304093, 0.105941, 0.63925, 0.26753, 1.136638), new Hue(34, -495.28, -19.8, 0.68962, 0.278886, 0.26378, 0.53962, 0.22631, 1.232286), new Hue(35, -498.45, -31.6, 0.659523, 0.258373, 0.392224, 0.5034, 0.19721, 1.310122), new Hue(40, -502.69, 43.2, 0.633815, 0.240851, 0.501944, 0.46041, 0.17495, 1.37661), new Hue(41, -509.12, 54.6, 0.60981, 0.22449, 0.604392, 0.42386, 0.15603, 1.438692), new Hue(42, -520.4, 65.8, 0.585492, 0.207915, 0.708175, 0.38991, 0.13846, 1.501583), new Hue(43, -536.31, 76.8, 0.558865, 0.189767, 0.821815, 0.35586, 0.12083, 1.570447), new Hue(44, -548.11, 86.8, 0.529811, 0.169965, 0.945807, 0.32195, 0.10328, 1.645584), new Hue(45, -555.96, 95.8, 0.496364, 0.147168, 1.088551, 0.28657, 0.08496, 1.732085), new Hue(46, -564.18, -108.4, 0.425346, 0.098764, 1.391643, 0.22202, 0.05155, 1.915754), new Hue(50, 450.0, -117.2, 0.3362, 0.038, 1.77211, 0.15664, 0.01771, 2.14631), new Hue(51, 468.71, -124.7, 0.210174, 0.086198, 1.353567, 0.12736, 0.05227, 1.64994), new Hue(52, 475.44, -131.8, 0.137734, 0.11477, 1.020911, 0.10813, 0.0902, 1.273415), new Hue(53, 479.0, -138.5, 0.101787, 0.135067, 0.843955, 0.09414, 0.12506, 1.080809), new Hue(54, 482.04, -145.1, 0.079004, 0.150709, 0.727863, 0.08249, 0.15741, 0.957577), new Hue(55, 484.29, -152.0, 0.062658, 0.164626, 0.641692, 0.07206, 0.18958, 0.868977), new Hue(56, 487.31, -163.4, 0.044691, 0.185949, 0.541091, 0.05787, 0.24109, 0.771732), new Hue(60, 490.4, -177.2, 0.030372, 0.211659, 0.455077, 0.04353, 0.30378, 0.69711), new Hue(61, 492.72, 171.6, 0.021655, 0.234022, 0.400126, 0.03291, 0.35696, 0.655804), new Hue(62, 495.28, 125.4, 0.013989, 0.261843, 0.348136, 0.0224, 0.41971, 0.623969), new Hue(63, 498.45, 148.4, 0.007215, 0.301137, 0.287685, 0.01196, 0.49954, 0.596037), new Hue(64, 502.69, 136.8, 0.002586, 0.366425, 0.238402, 0.00425, 0.60321, 0.607414), new Hue(65, 509.12, 125.4, 0.00726, 0.485346, 0.167317, 0.01099, 0.73542, 0.659924), new Hue(66, 520.4, 114.2, 0.06601, 0.717274, 0.076233, 0.0805, 0.83391, 0.859523), new Hue(70, 536.31, 103.2, 0.242272, 0.926325, 0.027086, 0.20259, 0.77474, 1.195684), new Hue(71, 548.11, 93.2, 0.406663, 0.990587, 0.010284, 0.28807, 0.7046, 1.410097), new Hue(72, 555.96, 84.2, 0.527646, 0.999862, 0.005321, 0.34422, 0.6523, 1.53283), new Hue(73, 560.74, 77.3, 0.606873, 0.993224, 0.003695, 0.37838, 0.6193, 1.603793), new Hue(74, 564.18, 71.6, 0.664599, 0.981981, 0.002868, 0.4029, 0.59533, 1.649449), new Hue(75, 566.78, 66.9, 0.708358, 0.970252, 0.00247, 0.42141, 0.57716, 1.681081), new Hue(76, 568.92, 62.8, 0.744182, 0.958592, 0.002205, 0.43647, 0.56222, 1.704981)]);
  c1 = new Vector3(3.54585104, 2.93225262, 2.41593945);
  x1 = new Vector3(0.69549072, 0.49228336, 0.2769988);
  y1 = new Vector3(0.02312639, 0.15225084, 0.52607955);
  c2 = new Vector3(3.9030714, 3.21182957, 3.96587128);
  x2 = new Vector3(0.11748627, 0.86755042, 0.6607786);
  y2 = new Vector3(0.8489713, 0.88445281, 0.73949448);
  FLIP_Y = new Vector2(1.0, -1.0);
  wave2 = wave2$init$();
  main();
  return _;
}));
